import React from 'react';
import { NextPage } from 'next';
import { makeStyles } from '@material-ui/core/styles';
import Main from '@/layouts/Main';
import { fetchIdeas } from '@/actions/idea';
import PageHeader from '@/components/common/PageHeader';
import BottomBanner from '@/components/common/BottomBanner';
import Head from '@/components/common/Head';
import IdeaListContainer from '@/containers/ideas/IdeaListContainer';
import styles from 'styles/jss/original/pages/ideas';
import meta from '@/config/meta';
import basicAuthentication from '@/lib/basicAuthentication';
import { wrapper, AppDispatch } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const IdeasPage: NextPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={meta.idea.title}
          description={meta.idea.description}
          image={meta.idea.image}
          url={meta.idea.url}
        />
        <PageHeader type='idea' />
        <div className={classes.main}>
          <IdeaListContainer />
          <BottomBanner />
        </div>
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ store, req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
  await (store.dispatch as AppDispatch)(fetchIdeas());
});

export default IdeasPage;
